// components/FunnelPopupModal.tsx
'use client';

import { Box, Button, Modal, useTheme } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';

import { FunnelLeadCapture } from '@/components/ContentBlocks/Funnel/Funnel';
import {
  ComponentBlocksFunnel,
  Enum_Componentblocksfunnel_Funnelvariant,
  Enum_Componentsharedbackground_Backgroundcolor,
  Enum_Componentsharedbackground_Backgroundorbs,
  Enum_Componentshareddisplayoptions_Contentswidth,
  Enum_Componentshareddisplayoptions_Paddingbottom,
  Enum_Componentshareddisplayoptions_Paddinginline,
  Enum_Componentshareddisplayoptions_Paddingtop,
} from '@/types';

export function FunnelPopupModal({
  block,
  timeout,
}: {
  block: ComponentBlocksFunnel;
  timeout: number;
}) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpen(true);
    }, timeout * 1000); // Convert seconds to ms

    return () => clearTimeout(timer);
  }, [timeout]);

  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        data-component="FunnelPopupModal"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'common.white',
          borderRadius: 2,
          boxShadow: 24,
          overflow: 'hidden',
          mx: 'auto',
          outline: 'none',
          padding: 0,
          minWidth: {
            xs: `calc(100% - ${theme.spacing(4)})`,
            sm: '35rem',
          },
        }}
      >
        <Button
          variant="text"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: '0',
            right: '-0.8rem',
            color: 'purple.600',
            zIndex: 2,
            '&:hover, &:focus': {
              color: 'brand.primary',
            },
          }}
        >
          <IconX />
        </Button>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            padding: {
              sm: 3,
            },
            paddingInline: {
              sm: 6,
            },
            '& .funnel-container': {
              background: 'unset',
              borderRadius: 'unset',
              maxWidth: 'auto',
              '& > *': {
                px: 0,
                py: 0,
              },
            },
          }}
        >
          <FunnelLeadCapture
            inPopup={true}
            block={{
              ...block,
              FunnelVariant: Enum_Componentblocksfunnel_Funnelvariant.Popup,
              FunnelBackground: {
                BackgroundColor: Enum_Componentsharedbackground_Backgroundcolor.None,
                BackgroundOrbs: Enum_Componentsharedbackground_Backgroundorbs.None,
                id: '0',
              },
              FunnelDisplayOptions: {
                CenterAlignImages: true,
                CenterAlignParagraphs: true,
                CenterAlignTitles: true,
                ContentsWidth: Enum_Componentshareddisplayoptions_Contentswidth.Narrow,
                PaddingBottom: Enum_Componentshareddisplayoptions_Paddingbottom.Xs,
                PaddingTop: Enum_Componentshareddisplayoptions_Paddingtop.Sm,
                PaddingInline: Enum_Componentshareddisplayoptions_Paddinginline.Xs,
                id: '0',
              },
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
}
